<template>
  <div>
    <PersonalAdd v-if="pageType === pageConfig.personal.type" />
    <EnterpriseAdd v-if="pageType === pageConfig.enterprise.type" />
    <EnterpriseSubAdd v-if="pageType === pageConfig.enterpriseSub.type" />
    <EnterpriseSubBatchAdd v-if="pageType === pageConfig.enterpriseSubBatch.type" />
  </div>
</template>

<script>
import { PAGE_CONFIG } from './config'
import PersonalAdd from './personalAdd.vue'
import EnterpriseAdd from './enterpriseAdd.vue'
import EnterpriseSubAdd from './enterpriseSubAdd.vue'
import EnterpriseSubBatchAdd from './enterpriseSubBatchAdd.vue'

export default {
  data() {
    return {
      pageType: '',
      pageConfig: PAGE_CONFIG,
    }
  },
  methods: {
    initPageType() {
      const { path } = this.$route

      let pageType = ''
      if (path.includes(this.pageConfig.personal.type)) {
        pageType = this.pageConfig.personal.type
      } else if (path.includes(this.pageConfig.enterpriseSubBatch.type)) {
        pageType = this.pageConfig.enterpriseSubBatch.type
      } else if (path.includes(this.pageConfig.enterpriseSub.type)) {
        pageType = this.pageConfig.enterpriseSub.type
      } else if (path.includes(this.pageConfig.enterprise.type)) {
        pageType = this.pageConfig.enterprise.type
      }

      this.pageType = pageType
    },
  },
  created() {
    this.initPageType()
  },
  components: {
    PersonalAdd,
    EnterpriseAdd,
    EnterpriseSubAdd,
    EnterpriseSubBatchAdd,
  },
}
</script>

<style lang="scss" scoped>
::v-deep label[for="isTranDeposit"] {
  height: auto;
}
</style>
